<template>
  <div class="data-clientComp">
    <div v-if="dataClient">
      <v-row>
        <v-col cols="4">
          <VTextFieldWithValidation
            :rules="{ required: true }"
            :label="$t('directService.customerData.name')"
            type="text"
            :disabled="defaultValues?.['firstName'] !== ''"
            v-model="dataClient['firstName']"
            :class="
              defaultValues?.['firstName'] !== ''
                ? 'textField-modification'
                : ''
            "
            @input="validateField"
          />
        </v-col>
        <v-col cols="4">
          <VTextFieldWithValidation
            :rules="{ required: true }"
            :label="$t('directService.customerData.secondName')"
            type="text"
            :disabled="isFieldDisabled"
            v-model="dataClient['lastName']"
            :class="isFieldDisabled ? 'textField-modification' : ''"
            @input="validateField"
          />
        </v-col>
        <v-col cols="4">
          <VTextFieldWithValidation
            :rules="{ required: false }"
            :label="$t('compensationSelection.clientForm.middleName')"
            type="text"
            v-model="dataClient['secondLastName']"
            @input="validateField"
          />
        </v-col>
      </v-row>
    </div>

    <div v-if="dataClient">
      <h4 class="dni-info">
        {{ $t("compensationSelection.clientForm.DNIinfo") }}
      </h4>
      <v-layout row wrap style="margin-left: 2px">
        <v-flex xs12 sm4>
          <v-select
            v-model="dataClient.documentTypes"
            filled
            background-color="white"
            :items="documentTypes"
            :label="$t('compensation.tipoDocumento')"
            @change="validateField"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm4 mt-5 mt-sm-0 class="pl-sm-2">
          <VTextFieldWithValidation
            :rules="documentNumberRules"
            :label="$t('compensation.numeroDocumento')"
            type="text"
            v-model="dataClient.documentNumber"
            @input="validateField"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import VTextFieldWithValidation from "@/components/dynamic/VTextFieldWithValidation.vue";
import { mapWritableState } from "pinia";
import { useCompensationStore } from "@/stores/compensationStore";
import { extend } from "vee-validate";

export default {
  name: "newDataClientDBG",
  components: {
    VTextFieldWithValidation,
  },
  props: {
    passenger: Object, // Recibe el pasajero seleccionado
  },
  data() {
    return {
      dataClient: this.passenger
        ? {
            firstName: this.passenger.BeneficiaryFirstName || "",
            lastName: this.passenger.BeneficiaryLastName || "",
            secondLastName: this.passenger.BeneficarySecondLastName || "",
            documentTypes:
              this.passenger.BeneficiaryDocType || "SIN_DOCUMENTACION",
            documentNumber: this.passenger.BeneficiaryDocNumber || "",
          }
        : {},
      defaultValues: null,
      isLastNameDisabled: false, // Nueva propiedad para controlar el estado del campo
      documentTypes: [
        {
          text: this.$i18n.t("compensation.others"),
          value: "SIN_DOCUMENTACION",
        },
        { text: this.$i18n.t("text.passport"), value: "PASAPORTE" },
        { text: this.$i18n.t("text.nif"), value: "NIF" },
        { text: this.$i18n.t("text.dniapr"), value: "DNI" },
        { text: this.$i18n.t("text.nie"), value: "NIE" },
      ],
      duplicateError: false,
    };
  },
  watch: {
    passenger: {
      immediate: true,
      handler(newPassenger, oldPassenger) {
        if (JSON.stringify(newPassenger) !== JSON.stringify(oldPassenger)) {
          this.dataClient = {
            firstName: newPassenger.BeneficiaryFirstName || "",
            lastName: newPassenger.BeneficiaryLastName || "",
            secondLastName: newPassenger.BeneficarySecondLastName || "",
            documentTypes:
              newPassenger.BeneficiaryDocType || "SIN_DOCUMENTACION",
            documentNumber: newPassenger.BeneficiaryDocNumber || "",
          };

          // Reasignar defaultValues completamente
          this.defaultValues = { ...this.dataClient };

          // Actualizar el estado de deshabilitación del apellido
          this.isLastNameDisabled = !!newPassenger.BeneficiaryLastName;
        }
      },
      deep: true,
    },
  },
  computed: {
    isFieldDisabled() {
      // Deshabilitar solo si el apellido viene del prop (defaultValues) y no ha sido modificado manualmente
      return (
        !!this.defaultValues?.lastName &&
        this.defaultValues.lastName.trim() !== ""
      );
    },
    documentNumberRules() {
      return {
        required: this.requiredRule,
        documentNumber: {
          type: this.dataClient.documentTypes,
          $t: this.$t,
        },
      };
    },
    ...mapWritableState(useCompensationStore, ["passengerData"]),
  },
  created() {
    const docNumberErrorMessage = this.$t("bankDetails.docNumberError");

    extend("documentNumber", {
      validate(value, { type }) {
        if (type === "NIE") {
          const nieRegex = /^[A-Za-z]{1}[0-9]{7,8}[0-9A-Za-z]{1}$/;
          return nieRegex.test(value);
        } else if (type === "DNI") {
          const dniRegex = /^[0-9]{8}[A-Za-z]{1}$/;
          return dniRegex.test(value);
        } else if (type === "NIF") {
          const nifRegex = /^[A-Za-z]{1}[0-9]{8}$/;
          return nifRegex.test(value);
        }
        return true;
      },
      params: ["type"],
      message: docNumberErrorMessage, // Usar el mensaje ya traducido aquí
    });
  },
  methods: {
    requiredRule(value) {
      return !!value || "Este campo es requerido";
    },
    validateField() {
      const validateRules = (value, rules) => {
        if (!Array.isArray(rules)) {
          return true;
        }
        return rules.every((rule) => {
          if (typeof rule === "function") {
            return rule(value) === true;
          } else if (rule.required) {
            return !!value || "Este campo es requerido";
          }
          return true;
        });
      };

      const isValid =
        this.dataClient.firstName &&
        this.dataClient.lastName &&
        validateRules(this.dataClient.firstName, [this.requiredRule]) ===
          true &&
        validateRules(this.dataClient.lastName, [this.requiredRule]) === true &&
        (this.dataClient.documentTypes === "SIN_DOCUMENTACION" ||
          validateRules(
            this.dataClient.documentNumber,
            this.documentNumberRules
          ) === true);

      this.dataClient.isValid = isValid;

      // Verificar duplicados
      this.checkForDuplicates();

      // Emitir eventos para validación y cambio de documento
      if (!isValid || this.duplicateError) {
        this.$emit("validation-error", this.dataClient);
      } else {
        this.$emit("validate-form", {
          lastName: this.dataClient.lastName,
          secondLastName: this.dataClient.secondLastName,
        });
        this.$emit("doc-change", {
          docNumber: this.dataClient.documentNumber,
          docType: this.dataClient.documentTypes,
        });
      }
    },
    checkForDuplicates() {
      const selectedPassengers = this.passengerData.filter(
        (passenger) =>
          passenger.BeneficiaryDocType === this.dataClient.documentTypes &&
          passenger.BeneficiaryDocNumber?.toLowerCase() ===
            this.dataClient.documentNumber?.toLowerCase() &&
          this.dataClient.documentNumber?.trim() !== ""
      );
      this.duplicateError = selectedPassengers.length > 1;
    },
  },
};
</script>

<style scoped lang="scss">
.main-background {
  background-color: #fafafa;
}
.data-clientComp {
  margin: 1em 1em 2em 2em;
  @media (min-width: 960px) {
    max-width: 80%;
  }
  .passenger-info {
    font-size: 20px;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    margin-top: 16px;
    margin-bottom: 16px;
    text-decoration: none;
    color: #0f2367;
  }
  .dni-info {
    font-size: 14px;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    margin-bottom: 16px;
    text-decoration: none;
    color: #0f2367;
  }
  .btn-bank {
    color: white;
    background-color: #2d69e1;
    margin-top: 10px;
    margin-bottom: 1rem;
    margin-left: auto;
    margin-right: auto;
    height: 48px;
    border-radius: 14px;
    font-size: 16px !important;
    padding: 12px 24px;
  }
  ::v-deep .textField-modification {
    .v-input__slot {
      background-color: #f6f6f6 !important;
      border-color: #f6f6f6 !important;
      flex: none !important;

      &::before,
      &::after {
        border: none !important;
      }
    }

    .v-text-field .v-label {
      color: #616161 !important;
      font-size: 16px !important;
      font-family: Roboto, sans-serif !important;
    }

    .theme--light.v-input--is-disabled input {
      color: rgba(0, 0, 0, 0.87) !important;
    }
  }
}
</style>
